import { render, staticRenderFns } from "./GetChecklistFieldModal.vue?vue&type=template&id=65b8dc18"
import script from "./GetChecklistFieldModal.vue?vue&type=script&lang=js"
export * from "./GetChecklistFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports